import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Whychoosechatbot() {
  return (
    <section
      className="why_choose_chatbot p-100"
      style={{ background: "#F8F8FB" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="resp_order text-center"
          >
            <StaticImage
              src="../../images/services-usa/chatbot-new/why_choose_chat.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={674}
              height={725}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <h2>Why Tekrevol’s Chatbot Development Services?</h2>
            <div className="chatbot_scroll_text">
              <p>
                Our chatbot developers have helped multiple teams automate
                repetitive, and low-value tasks by simply integrating our
                customizable chatbot solutions. Deployment of virtual assistants
                is not only limited to website and e-commerce; you can
                seamlessly pair them to any channel or process of your business,
                thereby enhancing team productivity, and attend to and resolve
                customer queries in no time.
              </p>
              <p>
                Adding our chatbot solutions will allow you to create a more
                intuitive, conversational, yet consistent experience for your
                customers. Moreover, you can always decrease human dependence
                for jobs that are repetitive, and have little to no creative
                scope. Inclusion of chatbots will improve the efficiency of
                communication channels across your enterprise systems, and
                result in a significant decrease in operational costs.
              </p>
              <p>
                As a chatbot development company and{" "}
                <Link to="https://www.tekrevol.com/ai-development-company">
                  artificial intelligence development company
                </Link>
                , we take pride in our AI engineering team. Our chatbot
                developers will design more personalized, yet scalable chatbot
                solutions that not only enhance interactions in chats, and
                conversations, but essentially become a virtual client assistant
                to walk the customer through your business, resulting in a
                delightful interaction that requires minimal human oversight.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosechatbot;
